export const alignAnimationsToPageClock = (root: Element) => {
  root.getAnimations({ subtree: true }).forEach((animation) => {
    const { duration, iterations } = animation.effect?.getComputedTiming() ?? {}

    if (
      iterations === Infinity &&
      typeof duration === 'number' &&
      duration > 0
    ) {
      animation.currentTime = performance.now() % duration
    }
  })
}
